module.exports = __webpack_public_path__ + "media/svg-new/002-writing-af00416f.svg";